import * as types from './types';
import { BookingService } from '../../services/booking-service';
import { requestCancellationErrorHandler, REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import { createHttpGetOptions } from '../../../../services/http/http-client';
import { validateResponse } from '../../../../services/http/response-validator';

let getContactsFormPromoterTokenSource = null;

export const bookingReportsActions = {

    async [types.GET_BOOKING_REPORTS_ARTIST_REPORT]({ commit, state }) {
        BookingService.getBookingReportsArtistReport().then(res => {
            commit(types.SET_BOOKING_REPORTS_ARTIST_REPORT, res.data);
        })
            .catch(requestCancellationErrorHandler);
    }

};